module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sj-bf11a7596686324ffe17b844d8d2da49.svg";